module.exports = __webpack_public_path__ + "img/contabilidad.b8d08f50.svg";